
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/m/[username]",
      function () {
        return require("private-next-pages/m/[username].js");
      }
    ]);
  